import { restClient } from '@/Core'

import type { EditSession } from '@/Ship/Components/OfficeViewer'

/** `kind` сесії документа диска — `DiskWopiProvider::KIND_FILE` беку. */
export const DISK_OFFICE_KIND = 'file'

const isEditSession = (value: unknown): value is EditSession => {
    if (value === null || typeof value !== 'object') return false

    const session = value as Record<string, unknown>

    return (
        typeof session['actionUrl'] === 'string' &&
        typeof session['accessToken'] === 'string' &&
        typeof session['accessTokenTtl'] === 'number' &&
        typeof session['fileName'] === 'string' &&
        typeof session['canWrite'] === 'boolean'
    )
}

/**
 * Перегляд документа диска в Collabora: `POST /services/disk/files/{uuid}/edit_session`
 * з тілом `{kind: 'file', mode: 'view'}` → `{actionUrl, accessToken,
 * accessTokenTtl, fileName, canWrite}` — контракт той самий, що в друкованих
 * форм (`OpenEditSessionTask` Ship, `EditSession`). Окрема операція, бо `kind`
 * друку — вид друкованого файлу (`word` | `pdf`), а контракт друку не
 * змінюємо. Редагування — фаза 3: на `edit` бек відповідає 422.
 */
export const OpenDiskOfficeSessionTask = async (uuid: string): Promise<EditSession> => {
    const response = (await restClient.post(`/services/disk/files/${encodeURIComponent(uuid)}/edit_session`, {
        json: { kind: DISK_OFFICE_KIND, mode: 'view' },
    })) as unknown

    if (!isEditSession(response)) {
        throw new Error('Редактор документів відповів незрозуміло. Спробуйте ще раз.')
    }

    return response
}
